var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{class:{ 'inactive-pro-badge': !_vm.isActive },attrs:{"src":require('@/assets/images/pro_badge.png'),"max-width":"50px","contain":""},on:{"click":function($event){$event.preventDefault();return _vm.routeToTripSubscription()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }